var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrowleft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M39.1082 22.1201H13.0006C12.9961 22.1201 12.9915 22.1107 12.9961 22.1107L22.8439 12.3297C23.6403 11.5397 23.6676 10.2277 22.8985 9.40477C22.134 8.58185 20.8643 8.55363 20.0679 9.34834L6.66147 22.6609C6.27011 23.0512 6.04712 23.592 6.04712 24.1516C6.04712 24.7159 6.27011 25.2519 6.66147 25.6423L20.1407 39.0301C20.5276 39.4157 21.0281 39.6085 21.5287 39.6085C22.0566 39.6085 22.5799 39.3968 22.9713 38.9736C23.7358 38.1507 23.7131 36.8387 22.9167 36.0487L13.0689 26.2677C13.0644 26.263 13.0689 26.2583 13.0735 26.2583H39.1537C40.2186 26.2583 41.0878 25.3977 41.1515 24.3162C41.2197 23.117 40.2686 22.1201 39.1082 22.1201Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.55332
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBack);
export default __webpack_public_path__ + "static/media/NavBack.0d85394db28e5f78c655d062d9e07319.svg";
export { ForwardRef as ReactComponent };